export default __webpack_public_path__ + "static/media/file-image_darkGray2.ecb4f15d.svg";